export enum Mode {
    DAILY_MESSAGE_EDIT,
    PRINTING,
    REPORT,
    RESERVATION_BROWSING,
    RESERVATION_CREATION,
    RESERVATION_EDIT,
    RESERVATION_PREVIEW_FROM_SEARCH,
    RESERVATION_PREVIEW,
    SEARCHING,
}

export enum ReservationBrowsingPeriod {
    SELECTED_HOUR,
    EVENING,
    MORNING,
}